import { z } from 'zod';

export enum HummingbirdEvents {
  BecomeKeyWindow = 'hummingbird-become-key-window',
  OpenThread = 'hummingbird-open-thread',
}

export const HummingbirdOpenThreadPayloadSchema = z.object({
  threadId: z.string(),
  draftContent: z.string().optional(),
  chatMode: z.string().optional(),
  draftContext: z.string().optional(),
});

export type HummingbirdThreadPayload = z.infer<
  typeof HummingbirdOpenThreadPayloadSchema
>;

export interface HummingbirdVisibilityPayload {
  visible: boolean;
  cursorPoint?: { x: number; y: number };
  bottomOffsetPx?: number;
  // Height of the macOS menu bar strip at the top of the display
  topInsetPx?: number;
  windowBounds?: { x: number; y: number; width: number; height: number };
}

export const HummingbirdWindowDimensions = {
  Width: 560,
  ActiveChatHeight: 592,
} as const;
